import {
  FailuresOverviewDto,
  JournalService,
  StationConfigDto,
  StationConfigExportDto,
  StationConfigItemDto,
  StationReadResultDto,
  StationTransferPlanDto,
  StationTransferRequestDto,
  StationTransferResultDto,
  StationWifiPasswordDto,
  SystemJournalDto,
  UserActionDto,
} from "../api";

// Журнал станции (только администратор): типы и запросы — из OpenAPI-контракта
const JournalApi = {
  getUserActions: async (controlBlockId: string, from: Date, to: Date, limit = 5000): Promise<UserActionDto[]> =>
    JournalService.getApiJournalActions(controlBlockId, from.toISOString(), to.toISOString(), limit),

  getSystemJournal: async (controlBlockId: string, from: Date, to: Date): Promise<SystemJournalDto> =>
    JournalService.getApiJournalSystem(controlBlockId, from.toISOString(), to.toISOString()),

  // Снимок настроек станции: текущий или на момент at
  getStationConfig: async (controlBlockId: string, at?: Date): Promise<StationConfigDto> =>
    JournalService.getApiJournalConfig(controlBlockId, at?.toISOString()),

  getStationConfigHistory: async (controlBlockId: string, settingKey: string, deviceId?: string | null): Promise<StationConfigItemDto[]> =>
    JournalService.getApiJournalConfigHistory(controlBlockId, settingKey, deviceId ?? undefined),

  // Пароль Wi-Fi или SIM (kind: "wifi" | "sim")
  getNetworkPassword: async (controlBlockId: string, kind: string, recordId?: string): Promise<StationWifiPasswordDto> =>
    JournalService.getApiJournalConfigWifiPassword(controlBlockId, recordId, kind),

  // Прочитать со станции Wi-Fi, LAN и SIM в снимок (на станции ничего не меняет)
  readFromStation: async (controlBlockId: string): Promise<StationReadResultDto[]> =>
    JournalService.postApiJournalConfigRead(controlBlockId),

  // Сводка сбоев по всем станциям: period — today, 7, 30, 365 (refresh — пересчитать сейчас)
  getFailuresOverview: async (period: string, refresh = false): Promise<FailuresOverviewDto> =>
    JournalService.getApiJournalFailures(period, refresh || undefined),

  exportStationConfig: async (controlBlockId: string, at?: Date): Promise<StationConfigExportDto> =>
    JournalService.getApiJournalConfigExport(controlBlockId, at?.toISOString()),

  // План переноса настроек со станции sourceId на станцию targetId (ничего не меняет)
  getStationTransferPlan: async (targetId: string, sourceId: string): Promise<StationTransferPlanDto> =>
    JournalService.getApiJournalConfigTransfer(targetId, sourceId),

  // Перенести отмеченные пункты плана на станцию targetId
  transferStationConfig: async (targetId: string, request: StationTransferRequestDto): Promise<StationTransferResultDto> =>
    JournalService.postApiJournalConfigTransfer(targetId, request),
};

export default JournalApi;
